/**
 * Tag domain types and schemas
 * Defines the core Tag entity with Effect Schema validation
 */

import { Schema } from "@effect/schema";

/**
 * Tag Schema - simple name-only tag
 */
export class TagSchema extends Schema.Class<TagSchema>("Tag")({
  id: Schema.UUID,
  name: Schema.String.pipe(Schema.minLength(1), Schema.maxLength(50)),
  createdAt: Schema.DateFromSelf,
}) {}

/**
 * Tag type derived from schema
 */
export type Tag = Schema.Schema.Type<typeof TagSchema>;

/**
 * Tag Response Schema (for API responses)
 */
export class TagResponseSchema extends Schema.Struct({
  id: Schema.UUID,
  name: Schema.String,
  createdAt: Schema.String,
}) {}

/**
 * Tag Response type
 */
export type TagResponse = Schema.Schema.Type<typeof TagResponseSchema>;

/**
 * Tags List Response Schema
 */
export class TagsListResponseSchema extends Schema.Struct({
  tags: Schema.Array(TagResponseSchema),
  total: Schema.Number,
}) {}

/**
 * Tags List Response type
 */
export type TagsListResponse = Schema.Schema.Type<typeof TagsListResponseSchema>;

/**
 * Converts Tag to TagResponse (for API serialization)
 */
export const toTagResponse = (tag: Tag): TagResponse => ({
  id: tag.id,
  name: tag.name,
  createdAt: tag.createdAt.toISOString(),
});

/**
 * Converts TagResponse to Tag (for API deserialization)
 */
export const fromTagResponse = (response: TagResponse): Tag => ({
  id: response.id,
  name: response.name,
  createdAt: new Date(response.createdAt),
});
